import React from "react"
import Store from "../FrazioniStore"
import Actions from "../FrazioniActions"
import { Frazione } from "../../generated";

interface IProps {
    codFisComune: string | undefined | null;
    codFrazione: string | undefined | null;
    selector: (stop: Frazione | null) => string | JSX.Element;
}
interface IState {
    stored: Frazione | null;
}

export class FrazioneData extends React.Component<IProps, IState>{
    constructor(props: IProps) {
        super(props);
        this.state = { stored: props.codFisComune ? Store.get(props.codFisComune)?.find(x => x.codFrazione == props.codFrazione) ?? null : null };
    }

    private listener = () => {
        const stop = this.props.codFisComune && Store.get(this.props.codFisComune)?.find(x => x.codFrazione == this.props.codFrazione) || null;
        if (this.state.stored != stop)
            this.setState({ stored: stop });
    }

    componentDidMount() {
        Store.Changed.register(this.listener);
        if (!this.state.stored && this.props.codFisComune)
            Actions.search(this.props.codFisComune)
    }

    componentDidUpdate(oldProps: IProps) {
        if (this.props.codFisComune !== oldProps.codFisComune && this.props.codFisComune) {
            let stored = Store.get(this.props.codFisComune)?.find(x => x.codFrazione == this.props.codFrazione);
            if (!stored)
                Actions.search(this.props.codFisComune);
            else {
                this.setState({ stored });
            }
        }
    }

    componentWillUnmount() {
        Store.Changed.unregister(this.listener);
    }

    static getStop(id: string) {
        return Store.get(id);
    }

    render() {
        const comune = this.state.stored;
        const content = this.props.selector(comune);
        return content;
    }
}